import {
  Box,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
  Stack,
  styled,
} from "@mui/material";
import React from "react";
import {
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";


const FocusAreaItem = styled(Box)(({ theme, bgcolor, bdColor }) => ({
  backgroundColor: bgcolor,
  border: `1px solid ${bdColor}`,
  borderRadius: 8,
  padding: theme.spacing(1.5),
//   marginBottom: theme.spacing(2),
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(2),
  "&:last-child": {
    marginBottom: 0,
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(1.5),
    gap: theme.spacing(1.5),
  },
}));
function CommonFocusArea({focusAreas}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          p: 2,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          gap:3
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 1 : 0,
          }}
        >
          <Typography
            variant={isMobile ? "h6" : "h6"}
            component="h1"
            fontWeight="600"
            color="text.primary"
            sx={{ textAlign: isMobile ? "center" : "left" }}
          >
            Focus Areas
          </Typography>
        </Box>

        <Stack spacing={1} >
          {focusAreas?.map((area) => {
            const IconComponent = area?.icon;
            return (
              <FocusAreaItem
                key={area?.id}
                bgcolor={area?.backgroundColor}
                bdColor={area?.bdColor}
              >
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    color: area.iconColor,
                    display: "flex",
                    justifyContent: "center",
                    alignItem: "center",
                  }}
                >
                  {/* <IconComponent
                    sx={{
                      color: area?.iconColor,
                      fontSize: isMobile ? 20 : 24,
                    }}
                  /> */}

                  {area?.icon}
                </Box>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography
                    variant="body1"
                    fontWeight="600"
                    color="text.primary"
                    gutterBottom
                    fontSize={13}
                  >
                    {area?.title}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    sx={{ lineHeight: 1.5 }}
                  >
                    {area?.description}
                  </Typography>
                </Box>
              </FocusAreaItem>
            );
          })}
        </Stack>
      </Paper>
    </>
  );
}

export default CommonFocusArea;
